"use client";

import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Quote() {
  const {
    ref: containerRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.2
  });
  return <section data-section-id="4535" id="getaquotecta" className="bg-background text-foreground relative w-full overflow-hidden">
      <div className="absolute inset-0 bg-cover bg-center bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1521681/img/plumbing_service_hero.png)]" />
      <div className="absolute inset-0" style={{
      background: "linear-gradient(135deg, hsla(220, 95%, 10%, 0.95) 0%, hsla(220, 95%, 20%, 0.85) 50%, hsla(220, 95%, 10%, 0.95) 100%)"
    }} />
      <div className="pointer-events-none absolute inset-0 opacity-[0.08] mix-blend-overlay" style={{
      backgroundImage: "url(\"data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='3' stitchTiles='stitch'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E\")"
    }} />

      <div className="relative z-10 mx-auto flex max-w-[800px] flex-col items-center px-6 py-32 text-center md:py-44">
        <div ref={containerRef} className={`flex flex-col items-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-6"}`}>
          <span className="font-sans text-xs font-bold tracking-[0.25em] text-accent uppercase mb-10">
            GET STARTED
          </span>

          <h2 className="font-display font-default font-bold text-white leading-[0.95] tracking-tight mb-16" style={{
          fontSize: "clamp(3.5rem, 8vw, 5rem)"
        }}>
            Get a Quote <span className="text-accent">Today</span>
          </h2>

          <div className="flex flex-col items-center gap-6">
            {/* TU BOTÓN EXACTO */}
            <Link to="https://aaeagleplumbing.com/contact/">
              <button className="bg-accent text-black hover:bg-accent-hover active:bg-accent-active hover:-translate-y-1 active:translate-y-0 hover:scale-105 active:scale-95 transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] shadow-medium hover:shadow-strong focus-visible:ring-2 focus-visible:ring-ring px-12 py-6 text-lg md:text-xl font-bold rounded-lg">
                Contact Us Now
              </button>
            </Link>
            
            <p className="text-xl md:text-2xl font-semibold mt-4 text-white">
              Or call us at{" "}
              <a href="tel:3055613895" className="text-accent hover:underline hover:opacity-80 transition-all">
                305-561-3895
              </a>
            </p>
          </div>

                  </div>
      </div>
    </section>;
}